import { action, observable, runInAction } from 'mobx';
import { UiResponse } from '../CommonInterfaces';
import ErrorUtil from '../util/ErrorUtil';
import RootStore from './RootStore';
import RouteStore from './RouteStore';
import UiStore from './UiStore';
import { API } from '../util/ApiUtil';
import { AxiosError } from 'axios';
import { View } from '../Routes';
import qs from 'qs';
import LanguageStore from './LanguageStore';

export default class ForgotPasswordStore {
  @observable accessor email: string = '';
  @observable accessor submitting: boolean = false;
  @observable accessor view: View | null = null;
  @observable accessor forgotPasswordModalOpen: boolean = false;

  private routeStore: RouteStore;
  private uiStore: UiStore;
  private languageStore: LanguageStore;

  public constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.uiStore = rootStore.uiStore;
    this.languageStore = rootStore.languageStore;
  }

  @action.bound
  public setEmail(email: string) {
    this.email = email;
  }

  @action.bound
  public init() {
    this.view = null;
    this.email = '';
  }

  @action.bound
  public setForgotPasswordModalState(isOpen: boolean) {
    this.forgotPasswordModalOpen = isOpen;
  }

  public async handleSubmit(recaptchaToken: string | null | undefined) {
    runInAction(() => {
      this.uiStore.hideNotices();
      this.submitting = true;
    });
    try {
      this.view = (
        await API.post('/email/forgot', {
          emailAddress: this.email,
          captchaToken: recaptchaToken,
          loginModel: { ...qs.parse(window.location.search, { ignoreQueryPrefix: true }), locale: this.languageStore.currentLanguage }
        })
      ).data.component;
      runInAction(() => {
        this.submitting = false;
      });
    } catch (e: Error | string | any) {
      this.handleError(e);
    }
  }

  @action.bound
  protected handleError(e: AxiosError<UiResponse>) {
    ErrorUtil.pushErrorToTeliaRumAndLog(e);
    this.submitting = false;
    this.forgotPasswordModalOpen = false;
    if (e.response?.data.redirectUrl) {
      return this.routeStore.route(e.response.data.redirectUrl);
    }
    this.uiStore.showErrorNoticeFromResponse(e.response);
  }
}
